import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI.js'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI.js'
import TermSheetNavUI from '../../../components/superUser/loan/TermSheetNavUI.js'
import LoanDocumentSubNavSF from '../../../components/superUser/loan/LoanDocumentSubNavSF.js'
import TermSheetScheduleRowsSF from '../../../components/superUser/loan/TermSheetScheduleRowsSF.js'

const TermSheetDocumentGeneralTermsPageUI = ({ context, errorList, loan, scheduleRowList, onRefreshClick }) =>
  <SuperUserLoanPageUI context={context} className='pg_su_ftl'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    loan={loan} page='termSheet'
    dimension='w1600'
  >
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Term sheet</b></span>
            </span>
          }
          right={<span />}
        />

        <TermSheetNavUI loan={loan} tab='document' />
        <LoanDocumentSubNavSF
          context={context}
          loan={loan}
          documentCode='term_sheet'
          basePath='termSheet'
          page='general'
          onRefreshClick={onRefreshClick}
        />

        <TermSheetScheduleRowsSF
          context={context}
          loan={loan}
          title='Schedule IV: General Terms and Conditions with optional Special Terms'
          scheduleRowList={scheduleRowList}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }
  </SuperUserLoanPageUI>

export default TermSheetDocumentGeneralTermsPageUI
